import { MyWorldDetailResponse, MyWorldStateType } from 'src/shared/types/src';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState: MyWorldStateType = {
  myWorldLoading: false,
  myWorldDetails: undefined,
};

const myWorldSlice = createSlice({
  name: 'myWorldSlice',
  initialState,
  reducers: {
    setMyWorldLoading: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.myWorldLoading = action.payload;
    },
    setMyWorldDetails: (
      state,
      action: PayloadAction<MyWorldDetailResponse>
    ) => {
      state.myWorldDetails = action.payload
    },
    resetMyWorldState: () => {
      return { ...initialState }
    }
  },
});

export const MyWorldActions = myWorldSlice.actions;
export default myWorldSlice.reducer;
